module.exports = __webpack_public_path__ + "static/media/tag-close-icon.10a940b1.svg";